import { apiClient } from "@/services/apiClient";

/** Everyone tied to the caller's agency: team members plus the contacts
 * on its clients (TD-086). Admin only. */
export type AgencyPersonKind = "team" | "client";

export interface AgencyPerson {
  id: string;
  name: string | null;
  email: string;
  kind: AgencyPersonKind;
}

interface AgencyPeopleResponse {
  people: AgencyPerson[];
}

export const agencyPeopleService = {
  async list(): Promise<AgencyPerson[]> {
    const res = await apiClient.get<AgencyPeopleResponse>("/api/agency/people");
    return res.people ?? [];
  },

  /** Set a person's global name (TD-086). A 409 rejects with the raw
   * axios error carrying ``{ code: "NAME_LOCKED" }``; see personName.ts. */
  async rename(personId: string, name: string): Promise<AgencyPerson> {
    return apiClient.patch<AgencyPerson>(`/api/agency/people/${personId}`, { name });
  },
};
